module.exports = __webpack_public_path__ + "baafb6676d05ef736bd0820fde9161d9.pdf";